import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Loader, OrdersTable } from "../..";
import { useHistoric } from "../../../hooks/useHistoric";

export default function BiddingList({ materialId }: { materialId: string }) {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);

  const { data: historic, isLoading: isLoadingHistoric } = useHistoric(
    materialId,
    page
  );

  return (
    <section>
      {isLoadingHistoric ? (
        <Loader />
      ) : (
        <OrdersTable
          orders={historic}
          title={t("order.succeed")}
          pageNumber={page}
          setPageNumber={setPage}
        />
      )}
    </section>
  );
}
